/* eslint-disable */
require('./action')
require('./agent')
require('./bookmark')
require('./building')
require('./caret-down')
require('./caret-left')
require('./caret-right')
require('./caret-up')
require('./chat')
require('./check')
require('./close')
require('./cube')
require('./disc')
require('./doctrine_stamp')
require('./doctrine')
require('./drag')
require('./empire')
require('./eye')
require('./faction')
require('./galaxy')
require('./infinite')
require('./layers')
require('./logo')
require('./marker')
require('./menu')
require('./notification')
require('./operation')
require('./options')
require('./overview')
require('./patent')
require('./pencil')
require('./production-queue')
require('./ranking')
require('./reaction')
require('./resize-grip')
require('./resource')
require('./ruler')
require('./search')
require('./share')
require('./ship')
require('./smiley')
require('./sort')
require('./spinner')
require('./square')
require('./stellar_body')
require('./stellar_system')
require('./unlock')
require('./victory')
